import React, { useState, useEffect } from "react";
import {
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    Grid,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Typography,
    TextField,
    FormControl,
    Select,
    MenuItem,
} from "@material-ui/core";
import { useStyles, StyledTableCell } from "../../adminStyles";
import { updateTimesheet } from "../../../../redux/timesheets/timesheetsActions";
import { useDispatch, useSelector } from "react-redux";

const EditDialogue = props => {
    const {
        dialogTitleContainer,
        dialogTitle,
        approveBtn,
        formControl,
        negativeBtn,
    } = useStyles();
    const dispatch = useDispatch();

    const { editOpen, handleEditClose, timesheet,projects } = props;
    const [timesheetCopy, setTimesheetCopy] = useState({});

    useEffect(() => {
        setTimesheetCopy({ ...timesheet });
    }, [timesheet]);

    const editColumns = [
        { title: "Date", id: "date" },
        { title: "Type", id: "task" },
        { title: "Hours", id: "hour" },
        { title: "Billable", id: "is_billable" },
        { title: "Project", id: "projectId" },
    ];

    const getProjectName = (id) => {
        if (projects) {
            let proj =  projects.find(project => project.projectId === id);
            return proj ? proj.projectName : "";
        }
    };
    const renderCells = (column, obj) => {
        if (column.id === "task") {
            return (
                <FormControl variant="outlined" className={formControl}>
                    <Select
                        value={obj.task}
                        onChange={e => {
                            obj.task = e.target.value;
                            setTimesheetCopy({
                                ...timesheetCopy,
                                weekly: [{ ...timesheetCopy.weekly[0] }],
                            });
                        }}
                    >
                        <MenuItem value={"regular"}>Regular</MenuItem>
                        <MenuItem value={"holiday"}>Holiday</MenuItem>
                        <MenuItem value={"vacation"}>Vacation</MenuItem>
                        <MenuItem value={"sick"}>Sick</MenuItem>
                        <MenuItem value={"bereavement"}>Bereavement</MenuItem>
                    </Select>
                </FormControl>
            );
        }
        if (column.id === "projectId") {
            return (
                <FormControl variant="outlined" className={formControl}>
                    <Select
                        value={obj.projectId}

                        onChange={e => {
                            obj.projectId = e.target.value;
                            setTimesheetCopy({
                                ...timesheetCopy,
                                weekly: [{ ...timesheetCopy.weekly[0] }],
                            });
                        }}
                    >
                        {timesheetCopy.projects.map(project => {
                             let name ='';
                             name=getProjectName(project.code);
                            return (
                                <MenuItem value={project.code}>
                                    {name}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            );
        }
        if (column.id === "hour") {
            return (
                <TextField
                    value={obj.hour}
                    type="number"
                    variant="outlined"
                    onChange={e => {
                        obj.hour = parseInt(e.target.value);
                        setTimesheetCopy({
                            ...timesheetCopy,
                            weekly: [{ ...timesheetCopy.weekly[0] }],
                        });
                    }}
                    inputProps={{
                        style: { textAlign: "center" },
                    }}
                />
            );
        }
        if (column.id === "is_billable") {
            return (
                <FormControl variant="outlined" className={formControl}>
                    <Select
                        value={obj.is_billable ? "Yes" : "No"}
                        onChange={e => {
                            obj.is_billable = e.target.value === "Yes";
                            setTimesheetCopy({
                                ...timesheetCopy,
                                weekly: [{ ...timesheetCopy.weekly[0] }],
                            });
                        }}
                    >
                        <MenuItem value="Yes">Billable</MenuItem>
                        <MenuItem value="No">Non-Billable</MenuItem>
                    </Select>
                </FormControl>
            );
        }
        
        return obj.date;
    };

    const handleSave = () => {
        const getTotalHours = () => {
            let days = timesheetCopy.weekly[0].days;
            let numArr = [];
            let total = 0;
            days.map(day => numArr.push(day.hour));
            total = numArr.reduce((acc, curr) => {
                return acc + curr;
            });
            return total;
        };

        let updatedTimesheet = {
            fromDate: timesheetCopy.weekly[0].fromDate,
            toDate: timesheetCopy.weekly[0].toDate,
            role: timesheetCopy.role,
            userId: timesheetCopy.id,
            mode: "Save",
            tsData: {
                users: [
                    {
                        id: timesheetCopy.id,
                        firstName: timesheetCopy.firstName,
                        middleName: timesheetCopy.middleName,
                        lastName: timesheetCopy.lastName,
                        emailId: timesheetCopy.emailId,
                        mobile: timesheetCopy.mobile,
                        role: timesheetCopy.role,
                        sick: timesheetCopy.sick,
                        vacation: timesheetCopy.vacation,
                        holiday: timesheetCopy.holiday,
                        active: timesheetCopy.active,
                        responseMessage: timesheetCopy.responseMessage,
                        weekly: [
                            {
                                tsId: timesheetCopy.weekly[0].tsId,
                                userId: timesheetCopy.id,
                                fromDate: timesheetCopy.weekly[0].fromDate,

                                toDate: timesheetCopy.weekly[0].toDate,

                                comments: timesheetCopy.weekly[0].comments,
                                status: timesheetCopy.weekly[0].status,
                                hours: getTotalHours(),
                                days: [...timesheetCopy.weekly[0].days],
                            },
                        ],
                    },
                ],
            },
        };

        dispatch(updateTimesheet(updatedTimesheet, "Submit"));
        handleClose();
    };

    // console.log("TIMESHEET COPY", timesheetCopy);

    const renderTableBody = () => {
        let days =
            Object.keys(timesheetCopy).length && timesheetCopy.weekly.length
                ? timesheetCopy.weekly[0].days
                : [];

        // console.log("DAYS", days);

        if (days) {
            return (
                Object.keys(timesheetCopy).length &&
                timesheetCopy.weekly.length &&
                days.map(day => {
                    return (
                        <TableRow hover>
                            {editColumns.map(column => {
                                return (
                                    <TableCell align="center">
                                        {renderCells(column, day)}
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    );
                })
            );
        }
        return "loading...";
    };

    const handleClose = () => {
        handleEditClose();
        setTimesheetCopy({});
    };

    const renderStyledTableCell = () =>
        editColumns.map(column => (
            <StyledTableCell align={"center"} padding={"default"}>
                {column.title}
            </StyledTableCell>
        ));

    return (
        <Dialog
            open={editOpen}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle
                id="form-dialog-title"
                className={dialogTitleContainer}
            >
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                >
                    <Typography variant="h5" className={dialogTitle}>
                        {`${timesheet.firstName} ${timesheet.lastName}`}
                    </Typography>
                </Grid>
            </DialogTitle>
            <DialogContent style={{ padding: 0 }}>
                <Table>
                    <TableHead>
                        <TableRow>{renderStyledTableCell()}</TableRow>
                    </TableHead>
                    <TableBody>{renderTableBody()}</TableBody>
                </Table>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button
                    onClick={handleClose}
                    color="primary"
                    className={negativeBtn}
                >
                    Close
                </Button>
                <Button
                    color="primary"
                    className={approveBtn}
                    onClick={handleSave}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditDialogue;
